// src/pages/Maintenance.tsx
import React, { useEffect } from "react";
import styled from "styled-components";
// Replace with your actual image import
import rovrliveLogo from "@assets/img/login-logo.svg";
import { useNavigate } from "react-router-dom";

const MaintenanceWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.darkBg};
  color: ${({ theme }) => theme.colors.white};
  width: 100vw;
  height: 100vh;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: ${({ theme }) => theme.breakpoints.mobile};
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: ${({ theme }) => theme.margins.medium};
  font-family: "Kern Standard", Arial, sans-serif;
`;

const Message = styled.p`
  font-family: "Kern Standard", Arial, sans-serif;
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 1.8;
  max-width: 600px;
  min-width: 480px;
  span {
    color: ${({ theme }) => theme.colors.yellow};
    font-weight: 400;
  }
`;

const Logo = styled.img`
  margin-top: ${({ theme }) => theme.margins["2xl"]};
  width: 160px;
  height: auto;
`;

export const MaintenancePage: React.FC = () => {
  const navigation = useNavigate();
  const [timesClicked, setTimesClicked] = React.useState(0);
  const timeoutRef = React.useRef<NodeJS.Timeout | null>(null);
  const onClickLogo = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      setTimesClicked(0);
    }, 2000);
    setTimesClicked((prev) => prev + 1);
    if (timesClicked === 5) {
      navigation("/maintenance-password");
    }
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef?.current);
      }
    };
  }, []);

  return (
    <MaintenanceWrapper>
      <Title>UNDER MAINTENANCE</Title>
      <Message>
        Our dashboard is currently being updated,
        <br /> <>and will be available soon.</>
        .<br />
        <br />
        Thanks you for your patience!
      </Message>
      <Logo onClick={onClickLogo} src={rovrliveLogo} alt="ROVR Logo" />
    </MaintenanceWrapper>
  );
};
